import { HttpStatus } from './constants';
import { Items } from '@app/src/commons/sidebar/components/Sidebar/types/Items';
import { decodeJwt } from '@app/src/views/Login/login/helpers/decodeJwt';
import { capitalizeWords } from '@app/src/utils/helpers';
import { decodeJwtMfa } from '@app/src/views/Login/login/helpers/decodeMfaJwt';

export const useAuthorization = (): boolean => {
  const token = sessionStorage.getItem('accessToken')
  if(token) {
    const { role } = decodeJwt(token)
    return role === 'user' || role === 'admin'
  }
  return false
};

export const validateTokenMfa = (): boolean => {
  const token = sessionStorage.getItem('mfaAccessToken')
  if(token) {
    const { status } = decodeJwtMfa(token)
    return status === 'pending_otp'
  }
  console.log('no existe token mfa o es invalido')
  return false
};

export class HttpResponseError extends Error {
  private status: number;
  private response: any;
​
  constructor(error) {
    super(error);
    this.name = 'HttpError';
    this.status = error.response.status;
    this.response = error.response.data;
    this.message = this.getMessage();
  }

  private getMessage = (): string => {
    if(this.status === HttpStatus.BAD_REQUEST) {
      return this.response.data
              .map(item => capitalizeWords(`${item.field} ${item.message}`));
    }
    return this.response.message;
  }
}

export const getHttpReponseCodeMessage = (code: number, response: any) => {
  if(code === HttpStatus.BAD_REQUEST) {
    return response.data.map(item =>  item.message)
  }
  return response.message;
};

export const getConfigsEnabled = (items: Items[]) => {
  return items
    .filter(item => item.enabled)
    .map(item => {
      delete item.enabled;
      return item;
    });
};

export const validatePassword = (password, allValues) => {
  return password !== allValues.newPassword ? 'Tus contraseñas no coinciden.' : '';
}

export const validateSecurityPassword = (password) => {
  const regex = /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*_0-9]).*$/;
  return regex.test(password) ? '' : 'La contraseña que has escrito no cumple con los requisitos de la directiva de contraseñas.';
}

export const required = (value: string) => {
  return value ? undefined : 'Campo requerido';
};

export const email = (value: string) => {
  return !/(\.{2}|-{2}|_{2})/.test(value) && /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/i.test(value) ? null : 'Formato no válido';
};

export const date = (value: string) => {
  return /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(value) ? null : 'Formato no válido';
};

export const minLength = (min: number) => (value: string) => {
  return value ? (value.length >= min ? null : `Ingrese mínimo ${min} caracteres`) : null;
};